"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpStatuses = void 0;
exports.getResponseError = getResponseError;
exports.sendSuccessStatus = sendSuccessStatus;
exports.handleError = handleError;
exports.sendErrorStatus = sendErrorStatus;
exports.sendUnknownErrorStatus = sendUnknownErrorStatus;
exports.prepareURL = prepareURL;
const Query_1 = require("./Query");
const httpStatusEnum_1 = require("./enums/httpStatusEnum");
const statusService_1 = require("../status/statusService");
const ApiError_1 = require("./ApiError");
const parseApiError_1 = require("./utils/parseApiError");
async function getResponseError(res) {
    const statusText = (0, exports.httpStatuses)()[res.status] || 'Unknown Error';
    const rawBody = await res.text();
    const body = (0, parseApiError_1.parseErrorBody)(rawBody);
    return new ApiError_1.ApiError(`${statusText} ${rawBody}`, {
        status: body?.status ?? res.status,
        title: body?.title,
        detail: body?.detail,
        name: statusText,
    });
}
function sendSuccessStatus() {
    (0, statusService_1.sendStatus)({
        variant: 'success',
        message: 'La petición se ha completado con éxito',
    });
}
function handleError(error) {
    if (error instanceof Error) {
        sendErrorStatus(error.message, error);
    }
    else {
        sendUnknownErrorStatus();
    }
}
function sendErrorStatus(message, error) {
    (0, statusService_1.sendStatus)({ variant: 'error', message, error });
}
function sendUnknownErrorStatus() {
    (0, statusService_1.sendStatus)({
        variant: 'error',
        message: 'Se produjo un error desconocido',
        error: new Error('Se produjo un error desconocido'),
    });
}
function prepareURL(resourceURL, params = {}) {
    const queryString = params instanceof Query_1.Query ? params.buildQuery() : buildQueryString(params);
    return queryString ? `${resourceURL}?${queryString}` : resourceURL;
}
function buildQueryString(params) {
    return Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
}
const httpStatuses = () => ({
    [httpStatusEnum_1.HTTPStatus.Continue]: 'Continue',
    [httpStatusEnum_1.HTTPStatus.SwitchingProtocol]: 'Switching Protocol',
    [httpStatusEnum_1.HTTPStatus.EarlyHints]: 'Early Hints',
    [httpStatusEnum_1.HTTPStatus.OK]: 'OK',
    [httpStatusEnum_1.HTTPStatus.Created]: 'Created',
    [httpStatusEnum_1.HTTPStatus.Accepted]: 'Accepted',
    [httpStatusEnum_1.HTTPStatus.NonAuthoritativeInformation]: 'Non Authoritative Information',
    [httpStatusEnum_1.HTTPStatus.NoContent]: 'No Content',
    [httpStatusEnum_1.HTTPStatus.ResetContent]: 'Reset Content',
    [httpStatusEnum_1.HTTPStatus.PartialContent]: 'Partial Content',
    [httpStatusEnum_1.HTTPStatus.MultipleChoices]: 'Multiple Choices',
    [httpStatusEnum_1.HTTPStatus.MovedPermanently]: 'Moved Permanently',
    [httpStatusEnum_1.HTTPStatus.Found]: 'Found',
    [httpStatusEnum_1.HTTPStatus.SeeOther]: 'See Other',
    [httpStatusEnum_1.HTTPStatus.NotModified]: 'Not Modified',
    [httpStatusEnum_1.HTTPStatus.TemporaryRedirect]: 'Temporary Redirect',
    [httpStatusEnum_1.HTTPStatus.PermanentRedirect]: 'Permanent Redirect',
    [httpStatusEnum_1.HTTPStatus.BadRequest]: 'Bad Request',
    [httpStatusEnum_1.HTTPStatus.Unauthorized]: 'Unauthorized',
    [httpStatusEnum_1.HTTPStatus.PaymentRequired]: 'Payment Required',
    [httpStatusEnum_1.HTTPStatus.Forbidden]: 'Forbidden',
    [httpStatusEnum_1.HTTPStatus.NotFound]: 'Not Found',
    [httpStatusEnum_1.HTTPStatus.MethodNotAllowed]: 'Method Not Allowed',
    [httpStatusEnum_1.HTTPStatus.NotAcceptable]: 'Not Acceptable',
    [httpStatusEnum_1.HTTPStatus.ProxyAuthenticationRequired]: 'Proxy Authentication Required',
    [httpStatusEnum_1.HTTPStatus.RequestTimeout]: 'Request Timeout',
    [httpStatusEnum_1.HTTPStatus.Conflict]: 'Conflict',
    [httpStatusEnum_1.HTTPStatus.Gone]: 'Gone',
    [httpStatusEnum_1.HTTPStatus.LengthRequired]: 'Length Required',
    [httpStatusEnum_1.HTTPStatus.PreconditionFailed]: 'Precondition Failed',
    [httpStatusEnum_1.HTTPStatus.PayloadTooLarge]: 'Payload Too Large',
    [httpStatusEnum_1.HTTPStatus.URITooLong]: 'URI Too Long',
    [httpStatusEnum_1.HTTPStatus.UnsupportedMediaType]: 'Unsupported Media Type',
    [httpStatusEnum_1.HTTPStatus.RangeNotSatisfiable]: 'Range Not Satisfiable',
    [httpStatusEnum_1.HTTPStatus.ExpectationFailed]: 'Expectation Failed',
    [httpStatusEnum_1.HTTPStatus.IAmATeapot]: "I'm a teapot",
    [httpStatusEnum_1.HTTPStatus.UnprocessableEntity]: 'Unprocessable Entity',
    [httpStatusEnum_1.HTTPStatus.TooEarly]: 'Too Early',
    [httpStatusEnum_1.HTTPStatus.UpgradeRequired]: 'Upgrade Required',
    [httpStatusEnum_1.HTTPStatus.PreconditionRequired]: 'Precondition Required',
    [httpStatusEnum_1.HTTPStatus.TooManyRequests]: 'Too Many Requests',
    [httpStatusEnum_1.HTTPStatus.RequestHeaderFieldsTooLarge]: 'Request Header Fields Too Large',
    [httpStatusEnum_1.HTTPStatus.UnavailableForLegalReasons]: 'Unavailable For Legal Reasons',
    [httpStatusEnum_1.HTTPStatus.InternalServerError]: 'Internal Server Error',
    [httpStatusEnum_1.HTTPStatus.NotImplemented]: 'Not Implemented',
    [httpStatusEnum_1.HTTPStatus.BadGateway]: 'Bad Gateway',
    [httpStatusEnum_1.HTTPStatus.ServiceUnavailable]: 'Service Unavailable',
    [httpStatusEnum_1.HTTPStatus.GatewayTimeout]: 'Gateway Timeout',
    [httpStatusEnum_1.HTTPStatus.HTTPVersionNotSupported]: 'HTTP Version Not Supported',
    [httpStatusEnum_1.HTTPStatus.VariantAlsoNegotiates]: 'Variant Also Negotiates',
    [httpStatusEnum_1.HTTPStatus.InsufficientStorage]: 'Insufficient Storage',
    [httpStatusEnum_1.HTTPStatus.LoopDetected]: 'Loop Detected',
    [httpStatusEnum_1.HTTPStatus.NotExtended]: 'Not Extended',
    [httpStatusEnum_1.HTTPStatus.NetworkAuthenticationRequired]: 'Network Authentication Required',
});
exports.httpStatuses = httpStatuses;
